import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound(){
  return (
    <div className="notfound">
      <Helmet><title>Page not found — Nomad Compass</title></Helmet>
      <div>
        <h1><em>404</em></h1>
        <p>The page you’re looking for doesn’t exist. It may have moved or the link might be mistyped.</p>
        <Link to="/" className="btn-primary">Back to home</Link>
      </div>
    </div>
  );
}
